import { requestApi } from '../util/network'

// 获取卖家商品列表
export const getGoodsList =
    (controller, params, keyword, goods_type, search_type) =>
      requestApi(
        '/' + controller + '/goods_list',
        'POST',
        {
          'keyword': keyword,
          'goods_type': goods_type,
          'search_type': search_type,
          'page': params.page,
          'per_page': params.per_page,
          'client_type': 'wap'
        },
        'seller'
      )
// 删除商品
export const dropGoods =
    (controller, commonid) =>
      requestApi(
        '/' + controller + '/drop_goods',
        'POST',
        {
          'commonid': commonid,
          'client_type': 'wap'
        },
        'seller'
      )
// 商品上架
export const goodsShow =
    (controller, commonid) =>
      requestApi(
        '/' + controller + '/goods_show',
        'POST',
        {
          'commonid': commonid,
          'client_type': 'wap'
        },
        'seller'
      )
// 商品下架
export const goodsUnshow =
    (controller, commonid) =>
      requestApi(
        '/' + controller + '/goods_unshow',
        'POST',
        {
          'commonid': commonid,
          'client_type': 'wap'
        },
        'seller'
      )
// 商品编辑
export const goodsEdit =
    (controller, commonid) =>
      requestApi(
        '/' + controller + '/edit_goods',
        'POST',
        {
          'commonid': commonid
        },
        'seller'
      )
// 商品规格值
export const goodsSpecAdd =
    (controller, name, gc_id, sp_id) =>
      requestApi(
        '/' + controller + '/add_spec',
        'POST',
        {
          'name': name,
          'gc_id': gc_id,
          'sp_id': sp_id
        },
        'seller'
      )
export const uploadInfoFile =
    (controller, file) =>
      requestApi(
        '/' + controller + '/image_upload',
        'POST',
        file,
        'seller',
        true
      )
export const uploadVideo =
    (controller, file) =>
      requestApi(
        '/' + controller + '/video_upload',
        'POST',
        file,
        'seller',
        true
      )
// 商品保存
export const goodsSave =
    (controller, class_id, commonid, goods, goods_body, sgcate_id, spec, sp_name, sp_val, attr, g_fccount, g_fcprefix) =>
      requestApi(
        '/' + controller + '/save_goods',
        'POST',
        {
          'class_id': class_id,
          'commonid': commonid,
          'goods': goods,
          'goods_body': goods_body,
          'sgcate_id': sgcate_id,
          'spec': spec,
          'sp_name': sp_name,
          'sp_val': sp_val,
          'attr': attr,
          'g_fcprefix': g_fcprefix,
          'g_fccount': g_fccount
        },
        'seller'
      )
// 获取店铺商品分类公共数据
export const getCommonData =
    (controller, class_id) =>
      requestApi(
        '/' + controller + '/get_common_data',
        'POST',
        {
          'class_id': class_id
        },
        'seller'
      )
// 图片编辑
export const imageEdit =
    (controller, commonid) =>
      requestApi(
        '/' + controller + '/edit_image',
        'POST',
        {
          'commonid': commonid
        },
        'seller'
      )
// 图片保存
export const imageSave =
    (controller, commonid, img) =>
      requestApi(
        '/' + controller + '/save_image',
        'POST',
        {
          'commonid': commonid,
          'img': img
        },
        'seller'
      )
// 获取店铺经营分类
export const getGoodsClass =
    (controller) =>
      requestApi(
        '/' + controller + '/goods_class',
        'POST',
        {

        },
        'seller'
      )
// banner保存
export const bannerSave =
    (controller, bannerImgList) =>
      requestApi(
        '/' + controller + '/banner_save',
        'POST',
        {
          banner: bannerImgList
        },
        'seller'
      )
// 促销折扣保存
export const discountSave =
    (controller, discountParam) =>
      requestApi(
        '/' + controller + '/discount_save',
        'POST',
        discountParam,
        'seller'
      )
// 查询banner和促销折扣
export const queryDiscount =
    (controller) =>
      requestApi(
        '/' + controller + '/getDiscount',
        'GET',
        {},
        'seller'
      )
// 货源商品列表
export const supplyGoodsList =
    (controller, params) =>
      requestApi(
        '/' + controller + '/inviteGoods',
        'GET',
        params || {},
        'seller'
      )
// 一键铺货
export const confirmSupplyGoodsByNum =
    (controller, params) =>
      requestApi(
        '/' + controller + '/addToMy',
        'POST',
        params || {},
        'seller'
      )
